import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import { SessionProvider } from './lib/session'
import { applyTheme, currentTheme } from './lib/theme'
import './index.css'

// The router basename comes from the build, so the same bundle works at the
// root of a host and under a subpath such as /journal.
const basename = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '')

applyTheme(currentTheme())

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={basename || undefined}>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
